import {useCallback} from 'react';
import * as Sentry from '@sentry/react';

const useSentryFeedbackWidget = (feedbackIntegration: ReturnType<typeof Sentry.getFeedback> | undefined) => {
  return useCallback(async () => {
    if (!feedbackIntegration) {
      return;
    }
    const form = await feedbackIntegration.createForm();
    form.appendToDom();
    form.open();
  }, [feedbackIntegration]);
};

export default useSentryFeedbackWidget;
